import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["submitQuery"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { setCancelBookingError } from "@Redux/bookTable/BookTable.actions";
import actions from "./actions";
import { getContactNameFromFirstNameAndLastName } from "@Components/BookTable/MainBookATable/Pages/useGetBooking";
import { format, parseISO } from "date-fns";
export var begin = () => ( /*#__PURE__*/function () {
  var _thunk = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.reset());
    dispatch(actions.begin({}));
  });
  function thunk(_x) {
    return _thunk.apply(this, arguments);
  }
  return thunk;
}());
export var submitSearch = payload => ( /*#__PURE__*/function () {
  var _thunk2 = _asyncToGenerator(function* (dispatch) {
    var {
      when
    } = payload;
    if (when) {
      var finalDate = when.date.replace("00:00", when.hour);
      dispatch(actions.search.submit(_objectSpread(_objectSpread({}, payload), {}, {
        finalDate
      })));
    } else {
      throw new Error("date or search are not deined correctfully");
    }
  });
  function thunk(_x2) {
    return _thunk2.apply(this, arguments);
  }
  return thunk;
}());
export var setSearch = payload => ( /*#__PURE__*/function () {
  var _thunk3 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.search.submit(_objectSpread({}, payload)));
  });
  function thunk(_x3) {
    return _thunk3.apply(this, arguments);
  }
  return thunk;
}());
export var editBooking = payload => ( /*#__PURE__*/function () {
  var _thunk4 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.booking.edit(_objectSpread({}, payload)));
  });
  function thunk(_x4) {
    return _thunk4.apply(this, arguments);
  }
  return thunk;
}());
export var submitBooking = payload => ( /*#__PURE__*/function () {
  var _thunk5 = _asyncToGenerator(function* (dispatch, getState) {
    var {
        submitQuery
      } = payload,
      data = _objectWithoutProperties(payload, _excluded);
    yield dispatch(actions.booking.edit(_objectSpread(_objectSpread({}, data), {}, {
      submitting: true
    })));
    var {
      bookTable: {
        booking
      }
    } = getState();
    var hourSplit = booking.when.hour.split(":")[0] + ":" + booking.when.hour.split(":")[1];
    var hourFormat = hourSplit.length === 5 ? "T".concat(hourSplit, ":00") : "T0".concat(hourSplit, ":00");
    try {
      var {
        data: {
          book_a_table: _data
        }
      } = yield submitQuery({
        variables: {
          // replace hour in date
          date: format(parseISO(booking.when.date), "yyyy-MM-dd") + hourFormat,
          ls_store_id: booking.store.id,
          contact_name: booking.who.contact_name,
          contact_email: booking.who.contact_email,
          notes: booking.quantity.notes ? booking.quantity.notes : "",
          request_cane: !!booking.quantity.request_cane,
          request_seggiolino: !!booking.quantity.request_seggiolino,
          request_disabili: !!booking.quantity.request_disabili,
          request_laurea: !!booking.quantity.request_laurea,
          request_compleanno: !!booking.quantity.request_cake,
          number_of_people: booking.quantity.quantity_internal,
          contact_phone_number: booking.who.contact_phone_number,
          contact_id: booking.contact_id ? booking.contact_id : ""
        }
      });
      if (_data.error_string || _data.error) throw _data.error_string || _data.error;
      dispatch(actions.booking.accept(_objectSpread(_objectSpread({}, booking), {}, {
        item_no: _data.item_no,
        id: _data.id
      })));
      return _data;
    } catch (e) {
      console.error(e);
      dispatch(actions.booking.reject(e));
    }
  });
  function thunk(_x5, _x6) {
    return _thunk5.apply(this, arguments);
  }
  return thunk;
}());
export var editExistingBooking = payload => ( /*#__PURE__*/function () {
  var _thunk6 = _asyncToGenerator(function* (dispatch, getState) {
    var {
      deleteQuery,
      createQuery
    } = payload;
    try {
      // Delete booking
      yield deleteQuery({
        variables: {
          booking_id: payload.id
        }
      });

      // Create a new one
      var {
        data: {
          book_a_table: data
        }
      } = yield createQuery({
        variables: _objectSpread(_objectSpread({}, payload), {}, {
          // replace hour in date
          date: payload.date.replace(/T.*$/, "T" + payload.hour)
        })
      });
      if (data.error_string || data.error) throw data.error_string || data.error;
      return data;
    } catch (e) {
      console.error(e);
    }
  });
  function thunk(_x7, _x8) {
    return _thunk6.apply(this, arguments);
  }
  return thunk;
}());
export var deleteExistingBooking = payload => ( /*#__PURE__*/function () {
  var _thunk7 = _asyncToGenerator(function* (dispatch) {
    var {
      deleteQuery
    } = payload;
    try {
      // Delete booking
      yield deleteQuery({
        variables: {
          booking_id: payload.id
        }
      });
      return true;
    } catch (e) {
      console.error(e);
      dispatch(setCancelBookingError(e));
    }
  });
  function thunk(_x9) {
    return _thunk7.apply(this, arguments);
  }
  return thunk;
}());
export var reset = () => ( /*#__PURE__*/function () {
  var _thunk8 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.reset());
  });
  function thunk(_x10) {
    return _thunk8.apply(this, arguments);
  }
  return thunk;
}());